import * as React from 'react';
import { LightboxAction } from '../use-lightbox-reducer';
import { LightboxDispatchContext } from './lightbox-dispatch.context';

export function useLightboxDispatch(): React.Dispatch<LightboxAction> {
    return React.useContext(LightboxDispatchContext);
}
